import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyD5fN7qcfwJAqFFA1bHK-QhWcSuCoGmZ4I",
  authDomain: "eap-finance.firebaseapp.com",
  projectId: "eap-finance",
  storageBucket: "eap-finance.firebasestorage.app",
  messagingSenderId: "389256820472",
  appId: "1:389256820472:web:f27906e177b8065e836d0d",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app)
export const storage = getStorage(app)
export const db = getFirestore(app)
